import { Box, Button, InputBase, Modal, Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomSearchTrackingMenu from "./CustomSearchTrackingMenu";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CloseOutlined } from "@mui/icons-material";
import CustomSearchTrackinPaper from "./CustomSearchTrackinPaper";
import { APIUrlThree, APIUrlToken, GetUserId } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import LegislativeMapMenu from "../../Pages/LegislativeMap/LegislativeMapMenu";

const CustomSearchTrackingModal = ({
  openCustomSearchModal,
  setOpenCustomSearchModal,
  handleTrackingdata,
  setLoading,
  editCustomSearchData,
  setEditCustomSearchData,
  isTabletLandscape
}) => {
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isTabletLandscape ? "90%" : "80vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };

  const [customSearchName, setCustomSearchName] = useState("");
  // keyword states------------------------------------------------
  const keyWordRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  const [allKeywordList, setAllKeywordList] = useState([
    "Advancement",
    "Increase",
    "Job Creation",
    "Improvement",
    "Growth",
    "Investment",
    "Innovation",
    "Development",
    "Acceleration",
    "Upgrades",
  ]);
  const handleKeywordList = () => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_keywords`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const data = response?.data?.keywords?.sort();
          setAllKeywordList(data);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const [keywordList, setKeywordList] = useState([]);

  const [isMenuKeyword, setIsMenuKeyword] = React.useState(false);
  const [keyword, setKeyword] = React.useState([]);

  const handleChangeKeyword = (event, item) => {
    if (event.target.checked) {
      setKeyword([...keyword, item]);
    } else {
      setKeyword(keyword?.filter((uncheck) => uncheck !== item));
    }
  };
  const handleSearchKeyword = (e) => {
    const value = e?.trim();
    setSearchText(value);

    if (value.length) {
      const data = allKeywordList?.filter((item) =>
        item?.toLowerCase()?.includes(value?.toLowerCase())
      );
      setKeywordList(data);
    } else {
      setKeywordList(allKeywordList);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (keyWordRef.current && !keyWordRef.current.contains(event.target)) {
        setIsMenuKeyword(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [keyWordRef]);

  // state states------------------------------------------------
  const stateRef = useRef(null);
  const [allStateList, setAllStateList] = useState([
    "Alabama",
    "California",
    "Florida",
    "Georgia",
    "Illinois",
    "Indiana",
    "Kentucky",
    "Michigan",
    "New York",
    "North Carolina",
    "Pennsylvania",
    "South Carolina",
    "Tennessee",
    "Texas",
    "Virginia",
    "West Virginia",
    "Wisconsin",
  ]);
  const getStateList = () => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: {},
      url: `${APIUrlThree()}/v1/get_cities`,
    };

    axios(options)
      .then((response) => {
        let dtaa = response.data.data.sort((a, b) =>
          a.toLowerCase().localeCompare(b.toLowerCase())
        );
        setAllStateList(dtaa || []);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching cities:", error);
        toast.error(
          error?.response?.data?.detail || error?.response?.data?.message
        );
      });
  };
  const [stateList, setStateList] = useState([]);
  const [isMenuState, setIsMenuState] = React.useState(false);
  const [state, setState] = React.useState([]);
  const handleChangeState = (event, item) => {
    if (event.target.checked) {
      setState([...state, item]);
    } else {
      setState(state?.filter((uncheck) => uncheck !== item));
    }
  };
  const handleSearchState = (e) => {
    if (e?.length) {
      const data = allStateList?.filter((item) =>
        item?.toLowerCase()?.includes(e?.toLowerCase())
      );
      setStateList(data);
    } else {
      setStateList(allStateList);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (stateRef.current && !stateRef.current.contains(event.target)) {
        setIsMenuState(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stateRef]);

  useEffect(() => {
    if (openCustomSearchModal) {
      handleKeywordList();
      getStateList();
    }
  }, [openCustomSearchModal]);

  // industry states------------------------------------------------
  const industryRef = useRef(null);
  const [allIndustryList, setAllIndustryList] = useState([
    "Advance Manufacturing",
    "Aerospace & Aviation",
    "Automotive",
    "Federal & Military",
    "Financial Services",
    "Food Sciences & Agriculture",
    "Healthcare",
    "Information Services & Software",
    "Logistics & Distribution",
    "Shale Energy & Petrochemicals",
  ]);
  const [industryList, setIndustryList] = useState([]);
  const [isMenuIndustry, setIsMenuIndustry] = React.useState(false);
  const [industry, setIndustry] = React.useState([]);
  const handleChangeIndustry = (event, item) => {
    if (event.target.checked) {
      setIndustry([...industry, item]);
    } else {
      setIndustry(industry?.filter((uncheck) => uncheck !== item));
    }
  };
  const handleSearchIndustry = (e) => {
    if (e?.length) {
      const data = allIndustryList?.filter((item) =>
        item?.toLowerCase()?.includes(e?.toLowerCase())
      );
      setIndustryList(data);
    } else {
      setIndustryList(allIndustryList);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (industryRef.current && !industryRef.current.contains(event.target)) {
        setIsMenuIndustry(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [industryRef]);

  // prospect states------------------------------------------------
  const prospectRef = useRef(null);
  const [searchQueryProspect, setSearchQueryProspect] = useState("");
  const [showProspectSearchData, setShowProspectSearchData] = useState(false);
  const [prospectResponseData, setProspectResponseData] = useState([]);
  const [selectedProspectData, setSelectedProspectData] = useState([]);

  const handleSearchPeople = React.useCallback(() => {
    if (!searchQueryProspect || searchQueryProspect?.length <= 2) return;
    setLoading(true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/people_search`,
      data: JSON.stringify({
        people_name: searchQueryProspect,
        page: 1,
        limit: 100,
      }),
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          setShowProspectSearchData(true);
          const data = response.data.data;
          const joinedData = data?.map((i) => ({
            ...i,
            name: `${i?.first_name} ${i?.last_name}, ${i?.primary_organization}`,
          }));
          setProspectResponseData(joinedData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  }, [searchQueryProspect, setLoading]);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      handleSearchPeople();
    }, 1000);
    return () => clearTimeout(timer);
  }, [searchQueryProspect]);

  const handleAddProspect = (item) => {
    setSelectedProspectData([...selectedProspectData, item]);
    setShowProspectSearchData(false);
    setSearchQueryProspect("");
    setProspectResponseData([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (prospectRef.current && !prospectRef.current.contains(event.target)) {
        setShowProspectSearchData(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [prospectRef]);

  // organization states------------------------------------------------
  const orgRef = useRef(null);
  const [searchQueryOrganization, setSearchQueryOrganization] = useState("");
  const [showOrganizationSearchData, setShowOrganizationSearchData] =
    useState(false);
  const [organizationResponseData, setOrganizationResponseData] = useState([]);
  const [selectedOrganizationData, setSelectedOrganizationData] = useState("");

  const handleSearchOrganization = React.useCallback(() => {
    if (!searchQueryOrganization || searchQueryOrganization?.length <= 2)
      return;
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/org_search`,
      data: JSON.stringify({
        org_name: searchQueryOrganization,
        page: 1,
        limit: 100,
      }),
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const cleanedData = response.data.map((org) => ({
            id: org.id,
            name: org.org_name,
          }));
          setShowOrganizationSearchData(true);
          setOrganizationResponseData(cleanedData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  }, [searchQueryOrganization, setLoading]);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      handleSearchOrganization();
    }, 1000);
    return () => clearTimeout(timer);
  }, [searchQueryOrganization]);

  const handleAddOrganization = (item) => {
    setSelectedOrganizationData(item);
    setShowOrganizationSearchData(false);
    setSearchQueryOrganization("");
    setOrganizationResponseData([]);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (orgRef.current && !orgRef.current.contains(event.target)) {
        setShowOrganizationSearchData(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [orgRef]);

  // date states------------------------------------------------
  const [isMenuDateRange, setIsMenuDateRange] = useState(false);
  const [dateRangeList, setDateRangeList] = useState([
    "Year-to-date",
    "Last 90 days",
    "Last 30 days",
  ]);
  const [dateRange, setDateRange] = useState("");
  const handleChangeDateRange = (item) => {
    setDateRange(item);
    setIsMenuDateRange(false);
  };

  // close modal cleanup------------------------------------------------
  const handleCloseSearchModal = () => {
    setOpenCustomSearchModal(false);
    setCustomSearchName("");

    setSelectedOrganizationData("");
    setShowOrganizationSearchData(false);
    setSearchQueryOrganization("");
    setOrganizationResponseData([]);
    setDateRange("");
    setIsMenuDateRange(false);
    setSelectedProspectData([]);
    setShowProspectSearchData(false);
    setSearchQueryProspect("");
    setProspectResponseData([]);
    setIndustryList([]);
    setIsMenuIndustry(false);
    setIndustry([]);

    setStateList([]);
    setIsMenuState(false);
    setState([]);

    setKeywordList([]);
    setIsMenuKeyword(false);
    setKeyword([]);
    setEditCustomSearchData([]);
  };

  const handleSaveCustomsearchData = async (type) => {
    if (!customSearchName || customSearchName.trim() === "") {
      toast.error("Please enter custom search news");
      return;
    }
    if (!selectedOrganizationData) {
      toast.error("Please select organization");
      return;
    }
    if (!dateRange) {
      toast.error("Please select date range");
      return;
    }
    if (keyword?.length && keyword?.length > 5) {
      toast.error("Please select up to 5 keywords.");
      return;
    }
    if (selectedProspectData?.length && selectedProspectData?.length > 5) {
      toast.error("Please select up to 5 Prospects.");
      return;
    }
    if (industry?.length && industry?.length > 5) {
      toast.error("Please select up to 5 industries.");
      return;
    }
    if (state?.length && state?.length > 5) {
      toast.error("Please select up to 5 states.");
      return;
    }
    let data = {
      name: customSearchName,
      user_id: Number(GetUserId()),
    };
    const query = {};
    let orgData = await getOrgDescription(selectedOrganizationData?.id);

    query.organization = {
      org_id: orgData?.org_id,
      org_name: orgData?.name,
      org_website: orgData?.website_url ? orgData?.website_url : "",
      linkedin: orgData?.linkedin ? orgData?.linkedin : "",
    };
    if (keyword?.length) {
      query.keywords = keyword;
    }
    if (selectedProspectData?.length) {
      query.prospects = selectedProspectData?.map((item) => ({
        person_id: item?.person_id,
        first_name: item?.first_name,
        last_name: item?.last_name,
        organization: item?.primary_organization || item?.organization,
        primary_job_title: item?.primary_job_title,
      }));
    }
    if (industry?.length) {
      query.industries = industry;
    }
    if (state?.length) {
      query.states = state;
    }

    data.timeframe =
      dateRange === "Last 30 days"
        ? "30-days"
        : dateRange === "Last 90 days"
        ? "90-days"
        : "year-to-date";

    data.query = query;
    try {
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/${
          type === "add"
            ? "custom_search_request"
            : `custom_search_request_update?interest_id=${editCustomSearchData?.request_id}`
        }`,
      };

      const response = await axios(option);
      setLoading(false);
      toast.success(response?.data?.message);
      handleCloseSearchModal();
      handleTrackingdata();
    } catch (error) {
      setLoading(false);
      console.error("Error fetching org description:", error);
    }
  };

  const getOrgDescription = async (id) => {
    setLoading(true);
    try {
      const option = {
        method: "GET",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/get_org_description?org_id=${id}`,
      };

      const response = await axios(option);
      if (response?.status === 200) {
        return response?.data?.data[0];
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching org description:", error);
    }
    return null;
  };

  useEffect(() => {
    if (editCustomSearchData?.request_id) {
      setCustomSearchName(editCustomSearchData?.custom_query_name);
      const parsedata = JSON.parse(editCustomSearchData?.custom_query);
      const orgjoinedData = [parsedata?.organization]?.map((i) => ({
        id: i?.org_id,
        name: `${i?.org_name} (${i?.org_website})`,
      }));
      setSelectedOrganizationData(orgjoinedData?.[0]);
      const joinedData = parsedata?.prospects?.map((i) => ({
        ...i,
        name: `${i?.first_name} ${i?.last_name}, ${i?.organization}`,
      }));
      setSelectedProspectData(joinedData || []);
      setKeyword(parsedata?.keywords || []);
      setIndustry(parsedata?.industries || []);
      setState(parsedata?.states || []);
      const date =
        parsedata.timeframe === "30-days"
          ? "Last 30 days"
          : parsedata.timeframe === "90-days"
          ? "Last 90 days"
          : "Year-To-Date";
      setDateRange(date);
    }
  }, [editCustomSearchData]);
  return (
    <>
      <Modal
        open={openCustomSearchModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="advance-search-modal">
          <Box sx={style2}>
            <h3 className="adv-search-modal adv-table-head-track">
              Build a Custom News Search{" "}
              <span className="red-search-track">*Required</span>
            </h3>
            <div className="table-head-track">
              {/* Required Fields */}
              <div className="track-mod-requ track-grid">
                <div>
                  <label className="track-label-modal">
                    <span className="mandatoryfields">*</span>Name Your Custom
                    News Search:
                  </label>
                  <Paper
                    className="track-full-searchbar-modal"
                    // component="form"
                    sx={{
                      p: "2px 4px",
                      display: "flex",
                      alignItems: "center",
                      width: isTabletLandscape ? "250px" : "300px",
                    }}
                  >
                    <InputBase
                      value={customSearchName}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setCustomSearchName(inputValue);
                      }}
                      className="search-inner-text track-cs-input"
                      sx={{ ml: 1, flex: 1 }}
                      placeholder={"Name"}
                      inputProps={{ "aria-label": "Search" }}
                      autoComplete="off"
                    />
                  </Paper>
                </div>

                <div ref={orgRef}>
                  <label className="track-label-modal">
                    <span className="mandatoryfields">*</span>Organization:
                  </label>
                  <CustomSearchTrackinPaper
                  isTabletLandscape={isTabletLandscape}
                    searchQuery={searchQueryOrganization}
                    setSearchQuery={setSearchQueryOrganization}
                    showSearchdata={showOrganizationSearchData}
                    responseData={organizationResponseData}
                    placeholder="Organization Name"
                    handleAddData={(item) => {
                      handleAddOrganization(item);
                    }}
                  />
                </div>
                <div>
                  <label className="track-label-modal">
                    <span className="mandatoryfields">*</span>Date Range:
                  </label>
                  <div className="crie_outer_drop">
                    <div
                      className="crie-drop-down-track"
                      style={{ textTransform: "none" }}
                      onClick={() => {
                        setIsMenuDateRange(!isMenuDateRange);
                      }}
                    >
                      Select
                      <KeyboardArrowDownIcon />
                    </div>
                    <div ref={industryRef}>
                      <LegislativeMapMenu
                        isMenuOpen={isMenuDateRange}
                        alldata={dateRangeList}
                        handleChange={handleChangeDateRange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="track-grid">
                <div></div>
                <div>
                  {selectedOrganizationData?.id ? (
                    <div className="display-kw-ci-pad">
                      <div className="flex-data-or">
                        <div className="crie_selected_names-track">
                          {selectedOrganizationData?.name}{" "}
                          <CloseOutlined
                            onClick={() => setSelectedOrganizationData()}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div>
                  {dateRange?.length ? (
                    <div className="display-kw-ci-pad">
                      <div className="flex-data-or">
                        <div className="crie_selected_names-track">
                          {dateRange}{" "}
                          <CloseOutlined onClick={() => setDateRange("")} />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="track-and-sec">
                And <span></span>
              </div>
              {/* Keyword */}
              <div className="track-modal-cont">
                <div className="crie_outer_drop">
                  <div
                    className="crie-drop-down-track"
                    style={{ textTransform: "none" }}
                    onClick={() => {
                      setIsMenuKeyword(!isMenuKeyword);
                      setKeywordList(allKeywordList);
                    }}
                  >
                    Keyword
                    <KeyboardArrowDownIcon />
                  </div>
                  <div ref={keyWordRef}>
                    <CustomSearchTrackingMenu
                      isMenuOpen={isMenuKeyword}
                      alldata={keywordList}
                      handleCheckboxChange={handleChangeKeyword}
                      checked={keyword}
                      handleSearch={handleSearchKeyword}
                      isSearch={true}
                      searchText={searchText}
                      setSearchText={setSearchText}
                    />
                  </div>
                </div>
                <ArrowForwardIosIcon className="track-modal-icon" />
                {/* {
                                    keyword?.length ? <div className='display-kw-ci'>
                                        {
                                            keyword?.map((item, index) => (
                                                <div className='flex-data-or'>
                                                    <div className='crie_selected_names-track'>{allKeywordList?.find(i => i == item)} <CloseOutlined onClick={() => setKeyword(keyword?.filter((uncheck) => uncheck !== item))} /></div>
                                                    {keyword?.length - 1 > index ? <span>or</span> : null}
                                                </div>
                                            ))
                                        }
                                    </div> : null
                                } */}
                {keyword?.length ? (
                  <div className="display-kw-ci">
                    {keyword?.map((item, index) => (
                      <div className="flex-data-or" key={index}>
                        <div className="crie_selected_names-track">
                          {item}
                          <CloseOutlined
                            onClick={() =>
                              setKeyword(
                                keyword?.filter((uncheck) => uncheck !== item)
                              )
                            }
                          />
                        </div>
                        {keyword?.length - 1 > index ? <span>or</span> : null}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="track-and-sec">
                And <span></span>
              </div>
              {/* Prospect */}
              <div className="track-modal-cont">
                <div ref={prospectRef}>
                  <CustomSearchTrackinPaper
                    searchQuery={searchQueryProspect}
                    setSearchQuery={setSearchQueryProspect}
                    showSearchdata={showProspectSearchData}
                    responseData={prospectResponseData}
                    placeholder="Prospect Name"
                    handleAddData={(item) => {
                      handleAddProspect(item);
                    }}
                  />
                </div>
                <ArrowForwardIosIcon className="track-modal-icon" />
                {selectedProspectData?.length ? (
                  <div className="display-kw-ci">
                    {selectedProspectData?.map((item, index) => (
                      <div className="flex-data-or">
                        <div className="crie_selected_names-track">
                          {item?.name}{" "}
                          <CloseOutlined
                            onClick={() =>
                              setSelectedProspectData(
                                selectedProspectData?.filter(
                                  (uncheck) =>
                                    uncheck?.person_id !== item?.person_id
                                )
                              )
                            }
                          />
                        </div>
                        {selectedProspectData?.length - 1 > index ? (
                          <span>or</span>
                        ) : null}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="track-and-sec">
                And <span></span>
              </div>
              {/* Industry Sector */}
              <div className="track-modal-cont">
                <div className="crie_outer_drop">
                  <div
                    className="crie-drop-down-track"
                    style={{ textTransform: "none" }}
                    onClick={() => {
                      setIsMenuIndustry(!isMenuIndustry);
                      setIndustryList(allIndustryList);
                    }}
                  >
                    Industry/Sector
                    <KeyboardArrowDownIcon />
                  </div>
                  <div ref={industryRef}>
                    <CustomSearchTrackingMenu
                      isMenuOpen={isMenuIndustry}
                      alldata={industryList}
                      handleCheckboxChange={handleChangeIndustry}
                      checked={industry}
                      handleSearch={handleSearchIndustry}
                      isSearch={true}
                    />
                  </div>
                </div>
                <ArrowForwardIosIcon className="track-modal-icon" />
                {industry?.length ? (
                  <div className="display-kw-ci">
                    {industry?.map((item, index) => (
                      <div className="flex-data-or">
                        <div className="crie_selected_names-track">
                          {allIndustryList?.find((i) => i == item)}{" "}
                          <CloseOutlined
                            onClick={() =>
                              setIndustry(
                                industry?.filter((uncheck) => uncheck !== item)
                              )
                            }
                          />
                        </div>
                        {industry?.length - 1 > index ? <span>or</span> : null}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="track-and-sec">
                And <span></span>
              </div>
              {/* State */}
              <div className="track-modal-cont">
                <div className="crie_outer_drop">
                  <div
                    className="crie-drop-down-track"
                    style={{ textTransform: "none" }}
                    onClick={() => {
                      setIsMenuState(!isMenuState);
                      setStateList(allStateList);
                    }}
                  >
                    State
                    <KeyboardArrowDownIcon />
                  </div>
                  <div ref={stateRef}>
                    <CustomSearchTrackingMenu
                      isMenuOpen={isMenuState}
                      alldata={stateList}
                      handleCheckboxChange={handleChangeState}
                      checked={state}
                      handleSearch={handleSearchState}
                      isSearch={true}
                    />
                  </div>
                </div>
                <ArrowForwardIosIcon className="track-modal-icon" />
                {state?.length ? (
                  <div className="display-kw-ci">
                    {state?.map((item, index) => (
                      <div className="flex-data-or">
                        <div className="crie_selected_names-track">
                          {allStateList?.find((i) => i == item)}{" "}
                          <CloseOutlined
                            onClick={() =>
                              setState(
                                state?.filter((uncheck) => uncheck !== item)
                              )
                            }
                          />
                        </div>
                        {state?.length - 1 > index ? <span>or</span> : null}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="de_hr-track">
                <div className="de_btn_cont">
                  <Button
                    className="de_cancel"
                    onClick={() => handleCloseSearchModal()}
                  >
                    Cancel
                  </Button>
                  {editCustomSearchData?.request_id ? (
                    <Button
                      className="de_next"
                      onClick={() => handleSaveCustomsearchData("update")}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      className="de_next"
                      onClick={() => handleSaveCustomsearchData("add")}
                    >
                      Save
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
};

export default CustomSearchTrackingModal;
